let prod_url = 'https://apps.tapestrykpi.com/marketplace';

export default prod_url;